import api from './api';

export type DyeInkType = string;

export interface DyeInkTypeOption { code: string; name: string; }
export interface DyeCatalogItemInput {
  ink_type: DyeInkType;
  category: 'ink' | 'chemical';
  name: string;
  code?: string;
  barrel_size_kg: string | number;
  monthly_average_usage_kg?: string | number;
}

export interface DyeStockHistoryItem {
  id: number;
  ink_type: string;
  category: 'ink' | 'chemical';
  name: string;
  code: string | null;
  card_color: string;
  barrel_size_kg: number | string | null;
  monthly_average_usage_kg: number | string;
  warehouse_barrels: number | string;
  warehouse_kg: number | string;
  department_barrels: number | string;
  department_kg: number | string;
  total_stock_kg: number | string;
  months_remaining: number | string | null;
}

export interface DyeStockMonthlyHistory {
  month: string;
  transaction_count: number;
  warehouse_received_kg: number;
  transferred_to_department_kg: number;
  department_issued_kg: number;
  department_returned_kg: number;
  warehouse_adjustment_kg: number;
  department_adjustment_kg: number;
  warehouse_net_change_kg: number;
  department_net_change_kg: number;
}

export interface DyeStockItemHistory {
  item: DyeStockHistoryItem;
  monthlyHistory: DyeStockMonthlyHistory[];
  transactionRange: {
    transaction_count: number;
    first_transaction_date: string | null;
    last_transaction_date: string | null;
  };
}

export const dyeStockService = {
  getTypes: (): Promise<DyeInkTypeOption[]> => api.get('/dye-stock/types').then(r => r.data.types),
  createType: (data: { name: string; code?: string }) => api.post('/dye-stock/types', data),
  seedCatalog: () => api.post('/dye-stock/seed-catalog'),
  getDashboard: (params?: { ink_type?: string; search?: string }) => api.get('/dye-stock/dashboard', { params }).then(r => r.data.items),
  getItems: (params?: { ink_type?: string; category?: string; search?: string }) => api.get('/dye-stock/items', { params }).then(r => r.data.items),
  getItemHistory: (id: number): Promise<DyeStockItemHistory> => api.get(`/dye-stock/items/${id}/history`).then(r => r.data),
  createItem: (data: DyeCatalogItemInput) => api.post('/dye-stock/items', data),
  updateItem: (id: number, data: any) => api.put(`/dye-stock/items/${id}`, data),
  deleteItem: (id: number) => api.delete(`/dye-stock/items/${id}`),
  getTransactions: (params?: any) => api.get('/dye-stock/transactions', { params }).then(r => r.data.transactions),
  createTransaction: (data: any) => api.post('/dye-stock/transactions', data),
  reverseTransaction: (id: number) => api.delete(`/dye-stock/transactions/${id}`),
};

export default dyeStockService;